var exports = {
  "k": "xa15a2ab7--e1fcee--container",
};

module.exports = exports;
